import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=584a4dbc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=584a4dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584a4dbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584a4dbc')) {
      api.createRecord('584a4dbc', component.options)
    } else {
      api.reload('584a4dbc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=584a4dbc&scoped=true&", function () {
      api.rerender('584a4dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W1a4VvzX4oh2/JS/comp/PopupBox.vue"
export default component.exports